import { AppStorage } from '@/modules/AppStorage';
import { useTranslate } from 'app/[locale]/hooks/useTranslate';
import { GlobalToastMessageContext } from 'libs/callabo-ui/contexts/GlobalToastMessageContext';
import { useCallback, useContext, useEffect, useState } from 'react';

export type Tooltip = 'share' | 'appInstall' | 'meetingChat';
const updatedAt: Record<Tooltip, string> = {
  share: '2025-04-24',
  appInstall: '2025-04-24',
  meetingChat: '2025-07-22',
};

export const useTooltip = (tooltipId: Tooltip) => {
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);
  const { toast } = useContext(GlobalToastMessageContext);

  useEffect(() => {
    (async () => {
      const storage = await AppStorage.create();
      const tooltips: Record<Tooltip, string> = await storage.get('tooltips');
      if (
        !tooltips?.[tooltipId] ||
        new Date(tooltips[tooltipId]) < new Date(updatedAt[tooltipId])
      ) {
        setVisible(true);
      }
    })();
  }, [tooltipId]);

  const closeTooltip = useCallback(async () => {
    try {
      const storage = await AppStorage.create();
      const tooltips: Record<Tooltip, string> = await storage.get('tooltips');
      await storage.set('tooltips', {
        ...tooltips,
        [tooltipId]: new Date().toISOString(),
      });
      setVisible(false);
    } catch (error) {
      toast(t.common.ERROR);
    }
  }, [tooltipId]);

  return { visible, closeTooltip };
};

/** @description update와 관계없이 tooltip 보여줄 필요가 있을 때 사용 */
export const resetTooltip = async (tooltipId: Tooltip) => {
  const storage = await AppStorage.create();
  const tooltips: Record<Tooltip, string> = await storage.get('tooltips');

  if (tooltips?.[tooltipId]) {
    delete tooltips[tooltipId];
    await storage.set('tooltips', tooltips);
  }
};
